<template lang="pug">
v-expansion-panels.route-layout
  v-expansion-panel(
    v-for="leg in value",
    :key="leg.legId",
  )
    v-expansion-panel-header Leg: {{ leg.name }}
    v-expansion-panel-content
      leg-configuration(v-model="leg.carriersId", v-bind="{ carriers }", :legTransportMode="leg.transportMode")
</template>

<script>
import EntityMixin from '@/mixins';
import LegConfiguration from '@/components/Shipment/LegConfiguration';

export default {
  mixins: [EntityMixin],
  props: {
    carriers: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    LegConfiguration,
  },
  data: () => ({}),
}
</script>
